import { renderRichText } from 'gatsby-source-contentful/rich-text'
import React from 'react'

import { Image, SVGImage } from '@leshen/gatsby-theme-leshen'

import { mapModules, mapRichText } from './determiners'

import {
  transformNavData,
  transformTopBarData,
} from './transformNavigationData'

export const richTextMutations = (richText) => {
  if (!richText) return null

  return renderRichText(richText, mapRichText())
}

export const headerMutations = (header) => {
  if (header?.__typename !== 'ContentfulHeader') return header

  const cloudinaryData = header?.logo?.cloudinary?.[0] || {}
  const { gatsbyImageData, svg: headerLogoSvg } = cloudinaryData

  const newHeaderData = {
    ...header,
    logo: headerLogoSvg ? (
      <SVGImage
        svg={headerLogoSvg?.code}
        presentationWidth={headerLogoSvg?.presentationWidth}
      />
    ) : (
      <Image data={gatsbyImageData} hasMarginBottom />
    ),
    linkGroups: transformNavData(header?.linkGroups),
    topBarLinks: transformTopBarData(header?.topBarLinks),
    textBlock:
      header?.textBlock && renderRichText(header?.textBlock, mapRichText()),
    topBarText:
      header?.topBarText && renderRichText(header?.topBarText, mapRichText()),
    callToActions: header.callToActions?.map(mapModules),
  }

  return newHeaderData
}

export const footerMutations = (footer) => {
  if (footer?.__typename !== 'ContentfulFooter') return footer

  const cloudinaryData = footer?.logo?.cloudinary?.[0] || {}
  const { gatsbyImageData, svg: footerLogoSvg } = cloudinaryData

  const newFooterData = {
    ...footer,
    logo: footerLogoSvg ? (
      <SVGImage
        svg={footerLogoSvg?.code}
        presentationWidth={footerLogoSvg?.presentationWidth}
      />
    ) : (
      <Image data={gatsbyImageData} hasMarginBottom />
    ),
    linkGroups: transformNavData(footer?.linkGroups) || footer.navData,
    disclaimers: footer?.disclaimers?.map((disclaimer) => disclaimer?.brandy),
  }

  return newFooterData
}
